import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_t43yn8tnfb: FaireBrandEntity = {
  token: "b_t43yn8tnfb",
  type: "brand",
  name: "Happy Aging",
  avatarUrl:
    "https://cdn.faire.com/fastly/4d7bedb424cb689a3486f399e30652dde1576acb10eea08bde1a36b67c97a85d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4c5f4022a1fb064fd0a5f304ca66b5e21c1c0a197fc5b571281d5dfd0b28be47.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4d7bedb424cb689a3486f399e30652dde1576acb10eea08bde1a36b67c97a85d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4c5f4022a1fb064fd0a5f304ca66b5e21c1c0a197fc5b571281d5dfd0b28be47.jpeg",
  location: "MIAMI, FL, USA",
  minimumOrderDollars: 150,
  rating: 4,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    "We’re redefining what it means to age by changing the narrative from anti-aging to pro-aging. Happy Aging is not just a wellness brand—it’s a powerful movement dedicated to celebrating life and empowering women to age better, healthier, and happier.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:28.926Z",
    importedBy: "entity-db-cli",
  },
};
